import React from 'react';
import { Label } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import BordereauStateFactory from '../../../../classes/bordereaux/state/BordereauStateFactory';

import './Bordereau.less';
import type BordereauStateType from '../../../../constants/liquidation/bordereaux/BordereauStateType';

interface FiltresBordereauProps {
  onChange: (bordereauStateType: number) => void;
  visibleStates: Set<BordereauStateType>;
}
const FiltresBordereauState = ({ onChange, visibleStates }: FiltresBordereauProps) => {
  if (visibleStates.size === 0) { return null; }

  return (
    <Combobox
      options={BordereauStateFactory.getAllStates().filter((state) => visibleStates.has(state.state)).map((state) => (
        {
          key: state.step,
          value: state.step,
          text: <Label
            horizontal
            style={{
              backgroundColor: state.color,
            }}
            size="medium"
            className="bordereau-label"
          >
            {state.libelle}
            {/* eslint-disable-next-line react/jsx-closing-tag-location */}
          </Label>,
        }
      ))}
      placeholder="Tous les états"
      clearable
      onChange={(_e, { value }: { value: number }) => onChange(value)}
    />
  );
};

export default FiltresBordereauState;
